<div class="d-flex flex-column justify-content-center menu-item logged-user">
  <div
    class="d-flex flex-row"
    [matMenuTriggerFor]="forCompanyMenu"
    [ngClass]="{ active: isRouteActive$ | async }">
    <div class="d-flex flex-column justify-content-center">
      <a
        class="font-weight-bold"
        data-cy="main-nav-our-products"
        [attr.title]="'header.who-we-are' | transloco">
        {{ 'header.who-we-are' | transloco }}
      </a>
    </div>

    <div class="d-flex flex-column justify-content-center">
      <mat-icon>expand_more</mat-icon>
    </div>
  </div>

  <mat-menu
    class="header-menu"
    #forCompanyMenu="matMenu">
    <a
      class="header-menu-item"
      mat-menu-item
      [attr.title]="items.ourPurposeItem.title | transloco"
      [href]="items.ourPurposeItem.link">
      {{ items.ourPurposeItem.title | transloco }}
    </a>
    <a
      class="header-menu-item"
      mat-menu-item
      [attr.title]="items.aboutUsItem.title | transloco"
      [href]="items.aboutUsLink">
      {{ items.aboutUsItem.title | transloco }}
    </a>
    <a
      class="header-menu-item"
      mat-menu-item
      [attr.title]="items.becomePartner.title | transloco"
      [href]="items.becomePartnerLink">
      ★ {{ items.becomePartner.title | transloco }}
    </a>
    <a
      class="header-menu-item"
      mat-menu-item
      [attr.title]="items.advisoryBoardItem.title | transloco"
      [href]="items.advisoryBoardLink">
      {{ items.advisoryBoardItem.title | transloco }}
    </a>
    <a
      class="header-menu-item"
      mat-menu-item
      [attr.title]="items.contactItem.title | transloco"
      [href]="items.contactLink">
      {{ items.contactItem.title | transloco }}
    </a>
  </mat-menu>
</div>
